import React from 'react'
import LoginButton from './LoginButton'

const LoginPage = () => {
    return (<LoginButton />);
}

export default LoginPage;